import React from 'react';
import { toInteger } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class CategorySelectComponent extends React.Component {
    onChange = e => this.props.onChangeCategory(toInteger(e.target.value));

    render() {
        const { categories, categoryId, CATEGORIES } = this.props;

        return (
            <div id="annuaire-rubriques-container" className="flex-container-h flex-center-alt">
                <label htmlFor="filtre" className="selection-filtre hidden-mobonly">
                    {CATEGORIES.CATEGORY} :{' '}
                </label>
                <div id="annuaire-rubriques" className="select">
                    <select
                        id="annuaire-rubriques-select"
                        value={categoryId}
                        onChange={this.onChange}>
                        <option value={-1}>{CATEGORIES.ALL_CATEGORIES}</option>
                        {categories.map((category, i) => {
                            return (
                                <option value={category.id} key={i}>
                                    {category.label}
                                </option>
                            );
                        })}
                    </select>
                </div>
            </div>
        );
    }
}

CategorySelectComponent.propTypes = {
    categories: PropTypes.array.isRequired,
    categoryId: PropTypes.number.isRequired
};

const mapStatetoProps = state => ({
    CATEGORIES: state.i18n.page.DIRECTORY.CATEGORIES
});

export default connect(mapStatetoProps)(CategorySelectComponent);



// WEBPACK FOOTER //
// ./src/components/pages/directory/filter/CategorySelectComponent.js